const debounce = (
  callback: { apply: (arg0: null, arg1: any[]) => void },
  wait: number | undefined,
) => {
  let timeoutId: number | undefined
  return (...args: any) => {
    window.clearTimeout(timeoutId)
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args)
    }, wait)
  }
}

export default debounce
